import Vue from 'vue';
import App from './App.vue';
import routerx from './router';
import store from './store';
import i18n, { translateError, withLocale } from './i18n';
import './plugins/element.js';
import Utils from './utils/utils';
import firebase from 'firebase';

import { loadStripe } from '@stripe/stripe-js';
// @ts-ignore
(async () => (Vue.prototype.$stripe = await loadStripe(process.env.VUE_APP_stripeApiKey)))();

Vue.config.productionTip = false;
Vue.prototype.$utils = Utils;

import '@/assets/linearicons/style.css';

// Initialize Firebase.
firebase.initializeApp({
	apiKey: process.env.VUE_APP_apiKey,
	authDomain: process.env.VUE_APP_authDomain,
	databaseURL: process.env.VUE_APP_databaseURL,
	projectId: process.env.VUE_APP_projectId,
	storageBucket: process.env.VUE_APP_storageBucket,
	appId: process.env.VUE_APP_appId,
});

Vue.use(require('vue-moment'));

let firestoreSettings: any = {};

// firebase.firestore.setLogLevel('debug')

firebase.firestore().settings(firestoreSettings);

if (process.env.NODE_ENV !== 'production') {
	firebase.firestore().useEmulator('localhost', 5002);
	firebase.functions().useEmulator('localhost', 5001);
}

firebase.auth().languageCode = i18n.locale;

Vue.prototype.$firebase = firebase;

// Firebase errors always come back in English; translate the known codes and
// fall back to the raw message.
Vue.prototype.$translateError = translateError;

// Carries the active locale over to the other Rambox apps.
Vue.prototype.$withLocale = withLocale;

const router = routerx(store);

new Vue({
	router,
	store,
	i18n,
	render: h => h(App),
}).$mount('#app');
